import { Loader2 } from 'lucide-react'

import { Button } from '@/modules/shared/components/ui/button'
import {
	Form,
	FormControl,
	FormField,
	FormItem,
	FormLabel,
	FormMessage,
} from '@/modules/shared/components/ui/form'
import { InputPassword } from '@/modules/shared/components/ui/input-password'
import { useAuthChangePassword } from '../hooks/use-auth-change-password.hook'
import { AuthLayoutComponent } from '../components/auth-layout.component'

export function AuthChangePasswordPage() {

	const { form, isLoading, submitAuthChangePassword } = useAuthChangePassword()

	return (
		<AuthLayoutComponent
			titleAuth="Alterar senha"
			navigation="Voltar para o login"
			route="/login"
		>
			<Form {...form}>
				<form onSubmit={form.handleSubmit(submitAuthChangePassword)}>
					<FormField
						control={form.control}
						name="senha"
						render={({ field }) => (
							<FormItem>
								<FormLabel>Senha</FormLabel>
								<FormControl>
									<InputPassword
										autoCapitalize="none"
										autoComplete="off"
										{...field}
										placeholder="Digite sua senha"
									/>
								</FormControl>
								<FormMessage>{form.formState.errors?.senha?.message}</FormMessage>
							</FormItem>
						)}
					/>

					<FormField
						control={form.control}
						name="confirmarSenha"
						render={({ field }) => (
							<FormItem>
								<FormLabel>Confirmar senha</FormLabel>
								<FormControl>
									<InputPassword
										autoCapitalize="none"
										autoComplete="off"
										{...field}
										placeholder="Confirme sua senha"
									/>
								</FormControl>
								<FormMessage>
									{form.formState.errors?.confirmarSenha?.message}
								</FormMessage>
							</FormItem>
						)}
					/>

					<div className="mt-8">
						<Button type="submit">
							{isLoading && <Loader2 size={24} className="animate-spin" />}
							Salvar
						</Button>
					</div>
				</form>
			</Form>
		</AuthLayoutComponent>
	)
}
